/**
 * Pagination: Prev, up to 3 page number links, Next.
 * Default 20 records per page.
 */
export const DEFAULT_PER_PAGE = 20;

export default function Pagination({ page, total, perPage, onPageChange }) {
  const totalPages = Math.max(1, Math.ceil(total / perPage));
  const clampedPage = Math.max(1, Math.min(page, totalPages));

  // Up to 3 page numbers: current and one on each side
  const start = Math.max(1, clampedPage - 1);
  const end = Math.min(totalPages, clampedPage + 1);
  const pageNumbers = [];
  for (let i = start; i <= end; i++) {
    pageNumbers.push(i);
  }

  return (
    <div className="d-flex justify-content-between align-items-center mt-3">
      <div className="small text-muted">
        {total > 0 && (
          <span>
            Showing {(clampedPage - 1) * perPage + 1}–
            {Math.min(clampedPage * perPage, total)} of {total}
          </span>
        )}
      </div>
      <div className="btn-group btn-group-sm">
        <button
          type="button"
          className="btn btn-outline-secondary"
          disabled={clampedPage === 1}
          onClick={() => onPageChange(1)}
        >
          Previous
        </button>
        {pageNumbers.map((p) => (
          <button
            key={p}
            type="button"
            className={`btn ${p === clampedPage ? "skedq-accent-btn" : "btn-outline-secondary"}`}
            onClick={() => onPageChange(p)}
          >
            {p}
          </button>
        ))}
        <button
          type="button"
          className="btn btn-outline-secondary"
          disabled={clampedPage >= totalPages}
          onClick={() => onPageChange(clampedPage + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
}
